var qwcNewCustomerPortal = ( function( module, $ ) {

	'use strict';

	// public methods
	var init ;

	// private methods
	var queryUserData, onUserDataRetrieved, cmGetSubscriptionStatus, shopifySearchForSubscriber, shopifyGetOrders, foxycartGetOrders ;
		
	// private properties
	var initialized = false ;
	var userData ;

	// DOM elements
	var $emailForm ;

	// deferreds
	var cmGetSubscriptionStatusDeferred ;
	var shopifySearchForSubscriberDeferred ;
	var shopifyGetOrdersDeferred ;
	var foxycartGetOrdersDeferred  ;



	init = function( options ) {
		if( initialized ) return ;

		// cache variables for DOM elements
		$emailForm = $( '#customer-email-form' ) ;

		// email form submit handler
		$emailForm.on( 'submit', function( e ) {
			e.preventDefault( ) ;
			var email = $( this ).find( 'input[type=email]' ).val( ) ;
			queryUserData( email ) ;
		} ) ;

		initialized = true ;
	} ;


	queryUserData = function( email ) {
		cmGetSubscriptionStatusDeferred = $.Deferred( ) ;
		shopifySearchForSubscriberDeferred = $.Deferred( ) ;
		shopifyGetOrdersDeferred = $.Deferred( ) ;
		foxycartGetOrdersDeferred = $.Deferred( ) ;

		$.when( cmGetSubscriptionStatusDeferred, 
			shopifyGetOrdersDeferred, 
			foxycartGetOrdersDeferred ).done( function( data_cm, data_shopify, data_foxycart ) {
				onUserDataRetrieved( data_cm, data_shopify, data_foxycart ) ;
		} ) ;

		cmGetSubscriptionStatus( email ) ;
		shopifySearchForSubscriber( email ) ;
		foxycartGetOrders( email ) ;
	} ;

	

	cmGetSubscriptionStatus = function( email ) {
		var list_id = 'ed026438c87fef02f44ef9fd98c85425' ;
		var url = 'https://api.createsend.com/api/v3.1/subscribers/' + list_id + '.json?callback=?' ;
		url = 'http://jsfiddle.net/echo/jsonp/' ;
		
		console.log( url ) ;

		$.ajax( {
			url: url,
			data: { email: email },
			type: 'post',
			dataType: 'jsonp',
			contentType: 'application/json',

			success: function( response ) {
				console.log( 'success! ' + response ) ;
				cmGetSubscriptionStatusDeferred.resolve( response ) ;
			},
			error: function( xhr, status, error ) {
				console.log( 'cmGetSubscriptionStatus.error:' + status + ' ' + error ) ;
			}
		} ) ;
	} ;

	shopifySearchForSubscriber = function( email ) {
		$.ajax( {
			url: '/admin/customers/search.json?query=' + email,

			yupe: 'get',
			dataType: 'json',
			success: function( response ) {
				shopifySearchForSubscriberDeferred.resolve( response ) ;
				shopifyGetOrders( data.id ) ;
			},
			error: function( xhr, status, error ) {
				console.log( 'shopifySearchForSubscriber.error: ' + status + ' ' + error ) ;
			}
		} ) ; 
	} ;

	shopifyGetOrders = function( userid) {
		$.ajax( {
			url: '/admin/orders.json?customer_id=' + userid,
			type: 'get',
			dataType: 'jsonp',
			success: function( response ) {
				shopifyGetOrdersDeferred.resolve( response ) ;
			},
			error: function( xhr, status, error ) {
				console.log( 'shopifyGetOrders.error: ' + textStatus ) ;
			}
		} ) ; 
	} ;

	foxycartGetOrders = function( email ) {

	} ;

	onUserDataRetrieved = function( data_cm, data_shopify, data_foxycart ) {
		console.log( 'all user data retrieved' ) ;
	} ;



	var module = { 
		init : init 
	} ;

	return module ;

} )( qwcNewCustomerPortal || {}, jQuery) ;



window.test = function( data ) {
	console.log( 'hi ' + data ) ;
} ;

$( document ).ready( function( ) {

	qwcNewCustomerPortal.init( ) ;

} ) ;